'use client'

import EnterViewAnimate from '@/components/enterView/animate'
import IconLocation from '@icon/variable/location.svg'
import { cn } from '@utils'
import { usePackageContext } from './context'

export default function PackageTabs() {
  const { tabs, tab, setTab } = usePackageContext()
  return (
    <section className='text-center mt-12.5'>
      <div className='inline-flex items-center bg-white rounded-lg'>
        {tabs.map((item) => (
          <button
            type='button'
            key={item.value}
            className={cn(
              'w-42.5 h-13.5 text-lg cursor-pointer transition-colors rounded-lg flex items-center justify-center',
              tab === item.value ? 'bg-primary text-white' : ''
            )}
            onClick={() => setTab(item.value)}
          >
            <IconLocation className='fill-white mr-2' />
            {item.label}
          </button>
        ))}
      </div>
    </section>
  )
}

export function ByLine() {
  const { tab } = usePackageContext()
  return (
    <EnterViewAnimate
      animate='animate__fadeInUp'
      className='max-w-187.5 mx-auto text-secondary/70'
    >
      {tab === 'au'
        ? 'Upgrade Package – Engage & Amplify & Maximise'
        : 'Upgrade Package – Essential & Social & Boost & Ultimate'}
    </EnterViewAnimate>
  )
}
